import * as React from "react";
import { useState } from 'react';
import { TextField, MaskedTextField } from '@fluentui/react';

interface FieldProps {
    setName(displayName: string): void;
    setEmptyWarning?(isEmpty: boolean): void;
    isEmpty?: boolean;
    defaultValue?: string;
    label?: string;
    id?: string;
    placeholder?: string;
    errorMsg?: string;
    errorMsgChars?: string;
    required?: boolean;
    mask?: string;
}

const MAX_CHARS = 256;

const hasValidLength = (name: string): boolean => {
    return name.length <= MAX_CHARS;
};

export const Field = (props: FieldProps) => {
    const { setName, setEmptyWarning, isEmpty, defaultValue } = props;
    const [isInvalidLength, setIsInvalidLength] = useState<boolean>(!hasValidLength(defaultValue ?? ''));

    const onNameTextChange = (
        event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>,
        newValue?: string
    ): void => {
        if (newValue === undefined) {
            return;
        }

        if (!hasValidLength(newValue)) {
            setIsInvalidLength(true);
            setName('');
            return;
        } else {
            setIsInvalidLength(false);
        }

        setName(newValue);
        if (setEmptyWarning && !newValue) {
            setEmptyWarning(true);
        } else {
            setEmptyWarning && setEmptyWarning(false);
        }
    };

    return (
        <>
            {!props.mask ?
                <TextField
                    autoComplete="off"
                    defaultValue={defaultValue}
                    label={props.label}
                    required={props.required}
                    onChange={onNameTextChange}
                    id={props.id}
                    placeholder={props.placeholder}
                    errorMessage={isEmpty ? props.errorMsg : isInvalidLength ? props.errorMsgChars : undefined}
                />
                :
                <MaskedTextField
                    defaultValue={defaultValue}
                    value={defaultValue}
                    label={props.label}
                    required={props.required}
                    onChange={onNameTextChange}
                    id={props.id}
                    validateOnLoad={false}
                    validateOnFocusOut
                    mask={props.mask}
                />
            }
        </>


    );
};
